import { Grid, Typography } from "@material-ui/core";
import React from "react";
import { WithIntlProps, injectIntl } from "react-intl";
import { PropertyNames, RequiredCandidateMyProfile } from "../../../data/constants";
import { CandidateViewModel } from "../../../model/CandidateViewModel";
import { GetTranslation } from "../../../translations/GetTranslation";
import GridTextField from "../../common/customGrid/GridTextField";
import TranslatedMessage from "../../translations/TranslatedMessage";

type ExpertFieldsProps = {
  expert: CandidateViewModel;
  isRequired: RequiredCandidateMyProfile;
  onPropertyValueChanges?: (part: Partial<CandidateViewModel>) => void;
} & WithIntlProps<any>;

const ExpertFields: React.FunctionComponent<ExpertFieldsProps> = ({ expert, intl, isRequired, ...handlers }) => {
  const handleTextChange =
    (key: keyof CandidateViewModel) => (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
      handleChange(key, event.target.value);

  const handleChange = (
    key: keyof CandidateViewModel,
    value: string | string[] | Date | boolean | null | undefined
  ) => {
    let part: Partial<CandidateViewModel> = {
      [key]: value,
    };

    if (handlers.onPropertyValueChanges) {
      handlers.onPropertyValueChanges(part);
    }
  };

  return (
    <>
      <Typography variant="h6">
        <TranslatedMessage id="person.section.expertDetails" />
      </Typography>
      <Grid container={true} spacing={4}>
        <GridTextField
          error={isRequired.isBankAccountEmpty}
          required
          label={GetTranslation(intl, "person.field.bankAccount")}
          xs={12}
          sm={6}
          md={4}
          onChange={handleTextChange(PropertyNames.bankAccount)}
          value={expert.bankAccount || ""}
        />
      </Grid>
    </>
  );
};

export default injectIntl(ExpertFields);
